import React from "react";
import { arrayOf, bool, shape, string } from "prop-types";

import BrandLinks from "../BrandLinks";
import MainNavigation from "../MainNavigation";
import MobileAppLinks from "../MobileAppLinks";
import NeighborhoodSection from "../NeighborhoodSection";
import SocialLinks from "../SocialLinks";
import * as S from "./styled";

const Footer = ({
  isBuildingSRP,
  isExpandedAreaSection,
  isHomePage,
  nearMeListingType,
  neighborhoods,
  platform,
  rootZendeskUrl,
  userIsRMC
}) => (
  <S.Wrapper className="jsFooterContainer jsCategoriesStopSticky">
    <S.Footer isExpandedAreaSection={isExpandedAreaSection} isWide={isHomePage}>
      <S.TopSection isExpandedAreaSection={isExpandedAreaSection}>
        {isExpandedAreaSection && (
          <S.NeighborhoodWrapper isExpandedAreaSection={isExpandedAreaSection}>
            <NeighborhoodSection
              isExpandedAreaSection={isExpandedAreaSection}
              neighborhoods={neighborhoods}
            />
          </S.NeighborhoodWrapper>
        )}

        <MainNavigation
          isBuildingSRP={isBuildingSRP}
          isExpandedAreaSection={isExpandedAreaSection}
          isHomePage={isHomePage}
          nearMeListingType={nearMeListingType}
          rootZendeskUrl={rootZendeskUrl}
          userIsRMC={userIsRMC}
        />
        {!isExpandedAreaSection && (
          <>
            <S.LinksWrapper>
              <MobileAppLinks platform={platform} />
            </S.LinksWrapper>
            <S.NeighborhoodWrapper>
              <NeighborhoodSection
                isExpandedAreaSection={isExpandedAreaSection}
                neighborhoods={neighborhoods}
              />
            </S.NeighborhoodWrapper>
          </>
        )}
      </S.TopSection>
      <S.HR />
      <S.BottomSection>
        {!isHomePage && <SocialLinks />}
        <S.ComplianceText isExpandedAreaSection={isExpandedAreaSection}>
          StreetEasy is a brand and registered trademark of Zillow, Inc. Zillow,
          Inc. has a real estate brokerage license in multiple states.{" "}
          <S.ComplianceLink href="https://www.zillow.com/info/real-estate-licenses/">
            See a list of these real estate licenses
          </S.ComplianceLink>
          .{" "}
          <S.ComplianceLink href="https://s.zillow.net/pfs/static/SOP_NYS.pdf">
            &#xA7; 442-H New York Standard Operating Procedures
          </S.ComplianceLink>
          .
        </S.ComplianceText>
        <BrandLinks />
        <S.CopyrightSection>
          <S.CopyrightItem>
            Zillow Inc. Sites &copy; 2006-{new Date().getFullYear()} Zillow
          </S.CopyrightItem>
          <S.DesktopOnly>
            <S.CopyrightItem>Made in NYC</S.CopyrightItem>
            <S.CopyrightItem>
              Powered by Bikes, Coffee, and Doughnuts.
            </S.CopyrightItem>
          </S.DesktopOnly>
        </S.CopyrightSection>
      </S.BottomSection>
      <S.Skyline height="393" width="984" />
    </S.Footer>
  </S.Wrapper>
);

Footer.propTypes = {
  isBuildingSRP: bool,
  isHomePage: bool,
  isExpandedAreaSection: bool,
  neighborhoods: arrayOf(
    shape({
      name: string,
      url: string,
      descendents: arrayOf(shape({ name: string, url: string }))
    })
  ),
  nearMeListingType: string.isRequired,
  rootZendeskUrl: string.isRequired,
  userIsRMC: bool,
  platform: string
};

Footer.defaultProps = {
  isBuildingSRP: false,
  isHomePage: false,
  neighborhoods: [],
  userIsRMC: false,
  isExpandedAreaSection: false,
  platform: ""
};

export default Footer;
